import { observer } from 'mobx-react'
import React from 'react'

import { useMapsUIStore } from '../../hooks/useMapsUIStore'
import {
   MapsUtilityContextProvider,
   MapsUtilityContextType
} from '../../hooks/useMapsUtilityContext'
import MapCoordinatesWithToolbar from '../MapCoordinatesWithToolbar/MapCoordinatesWithToolbar'
import MapsModal from '../MapsModal/MapsModal'
import MapsServiceProvider from '../MapsServiceProvider/MapsServiceProvider'

interface Props extends MapsUtilityContextType {}

const Maps = (props: Props): React.ReactElement => {
   const { isGeoMapModalOpen, config, closeGeoMapModal } = useMapsUIStore()

   const isReadOnly = config?.isDisabled || config?.isReadOnly

   return (
      <MapsUtilityContextProvider {...props}>
         <MapsModal>
            <MapsServiceProvider config={props.serviceProvidersConfig}>
               {isGeoMapModalOpen && config ? (
                  <MapCoordinatesWithToolbar
                     geoShape={config.response}
                     onUpdateGeoShape={config.onUpdateResponse}
                     isReadOnly={isReadOnly ?? false}
                     onCloseModal={closeGeoMapModal}
                  />
               ) : null}
            </MapsServiceProvider>
         </MapsModal>
      </MapsUtilityContextProvider>
   )
}

export default observer(Maps)
